import { render } from "./PendingLiquidation.vue?vue&type=template&id=2ccf7d06"
import script from "./PendingLiquidation.vue?vue&type=script&lang=js"
export * from "./PendingLiquidation.vue?vue&type=script&lang=js"

import "./PendingLiquidation.vue?vue&type=style&index=0&id=2ccf7d06&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__